import { Globe } from "lucide-react";
import { LANGS } from "../i18n/strings";
import { useI18n } from "../i18n";

export const LangSwitch = ({ disabled }) => {
  const { lang, setLang } = useI18n();
  return (
    <label className="lang-switch" title="Lingua / Language">
      <Globe size={13} />
      <select value={lang} onChange={(e) => setLang(e.target.value)} disabled={disabled} data-testid="lang-select" aria-label="Language">
        {LANGS.map((l) => <option key={l.code} value={l.code}>{`${l.label} · ${l.name}`}</option>)}
      </select>
    </label>
  );
};
